module.exports = __webpack_public_path__ + "img/home-img-5.fdd54a5c.webp";